
/////////////////////////////////////////////////////////////////////////
// GoogleFontsManager //////////////////////////////////////////////////////////
/////////////////////////////////////////////////////////////////////////
const GoogleFontsManager = {
  
  fontsLoaded: false,

  init: function(game) {

    this.game = game;

  },

  loadFontFamilies: function(families, callback, callbackContext) {

    this.callback = (callbackContext) ? callback.bind(callbackContext) : callback;

    //  The Google WebFont Loader will look for this object, so create it before loading the script.
    window.WebFontConfig = {

        //  'active' means all requested fonts have finished loading
        //  Do we need to set a 1 second delay before calling 'createText' to use these fonts? Not sure
        active: function() { 
          this.onFontsLoaded(true); 
        }.bind(this),

        //  The Google Fonts we want to load (specify as many as you like in the array)
        google: {
          families: families
        }

    };
    this.game.load.script('webfont', 'https://ajax.googleapis.com/ajax/libs/webfont/1.5.10/webfont.js');

    // set a timeout so game doesn't get hung up loading fonts
    PhaserUtils.TimeHelpers.makeOneShotTimer(this.onFontsLoaded, 3000, this, false);

  },

  onFontsLoaded: function(success) {

    this.fontsLoaded = true;
    this.callback();

  },

  testFonts: function(familyName, fontColor, weights) {

    var py = 0;
    weights.forEach(function(weight) {

      var test1 = this.game.add.text(200, py, familyName+' '+weight);
      test1.font = familyName;
      test1.fontSize = 80;
      test1.fontWeight = weight;
      test1.fill = fontColor;
      test1.updateText();

      py += 200;

    }, this);
  },

};

export default GoogleFontsManager;





// WEBPACK FOOTER //
// ./app/src/utils/display/GoogleFontsManager.js